export { default } from './member-card-async.js';
